import React from 'react';
import { AppRecordSubmitButton } from 'routes';
import { WorkOrderTaskType } from '@xbcb/work-order-types';
import { CloseCircleOutlined } from '@ant-design/icons';
import { WorkOrderTaskEvaluatedState } from 'libs/evaluateWorkOrderTaskState';
import { openCreateSellerCaseModal } from 'components/SupportCaseTab/component';
import { handleRejectTask } from 'libs/handleRejectTask';

const REJECT_TASK_WORK_ORDER_TASK_TYPES: WorkOrderTaskType[] = [
  WorkOrderTaskType.US_CONSUMPTION_ENTRY_BUILD_INVOICE,
  WorkOrderTaskType.US_CONSUMPTION_ENTRY_DOCUMENT_TAGGING,
  WorkOrderTaskType.US_CONSUMPTION_ENTRY_COMPLETION_SUBMISSION,
];

export const rejectWorkOrderTaskButton = (): AppRecordSubmitButton => {
  const rejectTaskButton: AppRecordSubmitButton = {
    key: 'rejectTask',
    text: () => (
      <div data-cy="reject-task-button">
        <CloseCircleOutlined /> Reject Task
      </div>
    ),
    show: ({
      workOrderTaskType,
      workOrderTaskEvaluatedState,
      existingRecord,
    }) => {
      const is1CCShipment =
        !!existingRecord?.group?.shipment?.legs?.[0]?.commercialInvoiceDetail
          ?.id;
      return (
        is1CCShipment &&
        workOrderTaskEvaluatedState === WorkOrderTaskEvaluatedState.STARTED &&
        !!workOrderTaskType &&
        REJECT_TASK_WORK_ORDER_TASK_TYPES.includes(
          workOrderTaskType as WorkOrderTaskType,
        )
      );
    },
    onConfirm: ({ existingRecord, workOrderTaskType, history }) => {
      const currentTask = existingRecord?.tasks?.find(
        (task: any) =>
          task?.definition?.workOrderTaskType === workOrderTaskType,
      );
      const bookingIdFromRecord =
        existingRecord?.group?.shipment?.clientReferences?.bookingId;
      openCreateSellerCaseModal(
        async (
          caseId,
          caseSubject,
          targetPartyType,
          externalUserType,
          metadata,
        ) => {
          const { rejectSellerDocuments, bookingId } = metadata || {};
          if (rejectSellerDocuments === 'Yes' && bookingId) {
            await handleRejectTask({
              bookingId,
              workOrderId: existingRecord?.id,
              workOrderVersion: existingRecord?.version,
              workOrderTaskId: currentTask?.id,
              push: history.push,
            });
          }
        },
        bookingIdFromRecord,
      );
      return Promise.resolve({ canceled: true });
    },
    skipValidation: () => true,
    skipUpdateRecord: () => true,
    onSubmit: () => Promise.resolve(),
  };
  return rejectTaskButton;
};
